





























































































import {
  defineComponent,
  computed,
} from '@vue/composition-api';
import {
  NOW,
  NOW_START_YEAR,
  NOW_START_MONTH,
  NOW_END_MONTH,
  toCommaFormat,
} from '@/utils';

import { useMutation, useQuery } from '@vue/apollo-composable';

import ChartWithLastYearCompare from '@/components/Report/ChartWithLastYearCompare.vue';
import ChartWithSelectedMonth from '@/components/Report/ChartWithSelectedMonth.vue';
import DonutExpenseByType from '@/components/Report/02-Expense/DonutExpenseByType.vue';
import DonutExpenseByHub from '@/components/Report/02-Expense/DonutExpenseByHub.vue';
import TreemapAreaExpense from '@/components/Report/02-Expense/TreemapAreaExpense.vue';
import HorizonStackByPayment from '@/components/Report/02-Expense/HorizonStackByPayment.vue';
import SmallChartPanel from '@/components/Report/SmallChartPanel.vue';

import overallExpense from '@/gql/managementReport/02-Expense/overallExpense.gql';
import monthsExpense from '@/gql/managementReport/02-Expense/monthsExpense.gql';
import expenseRange from '@/gql/managementReport/02-Expense/expenseRange.gql';
import expenseByHub from '@/gql/managementReport/02-Expense/expenseByHub.gql';
import expenseByArea from '@/gql/managementReport/02-Expense/expenseByArea.gql';
import expenseByPaymentAccount from '@/gql/managementReport/02-Expense/expenseByPaymentAccount.gql';

const DeliveryIncome = defineComponent({
  components: {
    SmallChartPanel,
    ChartWithLastYearCompare,
    ChartWithSelectedMonth,
    DonutExpenseByType,
    DonutExpenseByHub,
    TreemapAreaExpense,
    HorizonStackByPayment,
  },
  setup() {
    const { result: getTopInfo } = useQuery(overallExpense, computed(() => ({
      timeframe: { from: NOW_START_YEAR, to: NOW },
      timeframeY1: { from: NOW_START_MONTH, to: NOW },
    })));
    const getPanelInfo = computed(() => getTopInfo.value?.overallExpense || {});
    const getPanelInfoMtd = computed(() => getTopInfo.value?.overallExpenseMTD || {});

    return {
      overallExpense,
      monthsExpense,
      expenseRange,
      expenseByHub,
      expenseByPaymentAccount,
      expenseByArea,

      getPanelInfo,
      getPanelInfoMtd,
    };
  },
});

export default DeliveryIncome;
